import { AB_PIN_CARD_MAGNIFIER } from "@/constants/ABMng";
import useABTest from "./useABtest";

/**
 * 采集卡片放大镜功能 AB 实验 Hook
 *
 * @returns {
 *   showMagnifier: boolean,      // 是否显示放大镜功能（string_1 或 string_3 时返回 true）
 *   isNewLayout: boolean,        // 是否使用新布局模式（用于 FoldCard 等组件，string_1 或 string_3 时返回 true）
 *   extraColumns: number,        // 额外的列数（string_3 时返回 1，string_1 时返回 0，其他返回 0）
 *   loading: boolean,           // 实验加载状态
 *   value: string,              // 实验原始值
 * }
 *
 * @example
 * // 在卡片组件中使用
 * const { showMagnifier } = usePinCardMagnifier();
 *
 * // 在 FoldCard 中使用
 * const { isNewLayout } = usePinCardMagnifier();
 *
 * // 在瀑布流计算中使用
 * const { extraColumns } = usePinCardMagnifier();
 */
export function usePinCardMagnifier() {
  const magnifierABTest = useABTest(AB_PIN_CARD_MAGNIFIER);

  // string_1: 只开启放大镜功能，不改变列数
  // string_3: 开启放大镜功能，列数+1
  const isMagnifierEnabled =
    magnifierABTest.value === "string_1" ||
    magnifierABTest.value === "string_3";
  const extraColumns = magnifierABTest.value === "string_3" ? 1 : 0;

  return {
    showMagnifier: isMagnifierEnabled,
    isNewLayout: isMagnifierEnabled,
    extraColumns,
    loading: magnifierABTest.loading,
    value: magnifierABTest.value,
  };
}
